import React, { useState, useRef, useEffect } from 'react';
import { Navbar as BootstrapNavbar, Container, Nav, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Menu, User, LogOut, ChevronDown } from 'lucide-react';
import useAuth from '../../hooks/useAuth';

const Navbar = ({ toggleSidebar }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleLogout = () => {
        setOpen(false);
        logout();
    };

    const roleLabel =
        user?.roles?.includes('ROLE_ADMIN') ? 'Administrateur' :
        user?.roles?.includes('ROLE_MANAGER') ? 'Manager' :
        user?.roles?.includes('ROLE_SALES_REP') ? 'Commercial' :
        user?.roles?.includes('ROLE_DISTRIBUTOR') ? 'Distributeur' :
        user?.roles?.includes('ROLE_WAREHOUSE_MANAGER') ? 'Warehouse Manager' :
        'User';

    // Fermer le menu au clic en dehors
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <BootstrapNavbar bg="white" expand="lg" className="border-bottom shadow-sm py-2">
            <Container fluid>
                <Button
                    variant="link"
                    className="p-0 me-3 d-lg-none"
                    onClick={toggleSidebar}
                >
                    <Menu size={24} />
                </Button>

                <BootstrapNavbar.Brand href="/dashboard" className="fw-bold">
                    Soplast Group
                </BootstrapNavbar.Brand>

                <Nav className="ms-auto d-flex flex-row align-items-center">
                    {/* Dropdown profil fait main : le menu est en position absolue,
                        il flotte au-dessus du contenu et ne décale jamais la barre. */}
                    <div ref={dropdownRef} style={{ position: 'relative' }}>
                        <div
                            className="d-flex align-items-center"
                            style={{ cursor: 'pointer' }}
                            onClick={() => setOpen((o) => !o)}
                        >
                            <div className="rounded-circle bg-light p-1 me-2 d-flex align-items-center justify-content-center">
                                <User size={24} />
                            </div>
                            <div className="d-none d-sm-block text-start">
                                <div className="fw-semibold">
                                    {user?.fullName || user?.username || 'User'}
                                </div>
                                <div className="small text-muted">{roleLabel}</div>
                            </div>
                            <ChevronDown
                                size={16}
                                className="ms-2"
                                style={{
                                    transition: 'transform 0.2s ease',
                                    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                                }}
                            />
                        </div>

                        {open && (
                            <div
                                className="bg-white border rounded shadow py-2"
                                style={{
                                    position: 'absolute',
                                    top: 'calc(100% + 8px)',
                                    right: 0,
                                    minWidth: '210px',
                                    zIndex: 1050,
                                }}
                            >
                                <button
                                    type="button"
                                    className="dropdown-item d-flex align-items-center py-2"
                                    onClick={() => { setOpen(false); navigate('/profile'); }}
                                >
                                    <User size={16} className="me-2" />
                                    Profil
                                </button>
                                <hr className="my-1" />
                                <button
                                    type="button"
                                    className="dropdown-item d-flex align-items-center py-2 text-danger"
                                    onClick={handleLogout}
                                >
                                    <LogOut size={16} className="me-2" />
                                    Se déconnecter
                                </button>
                            </div>
                        )}
                    </div>
                </Nav>
            </Container>
        </BootstrapNavbar>
    );
};

export default Navbar;